import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import { LocalizationProvider } from '@material-ui/pickers';
import DayjsUtils from '@material-ui/pickers/adapter/dayjs';
// NOTE: 這些 import 只是為了讓 dayjs 註冊語系（side effect），值本身不使用。
// 千萬不要把 locale 物件傳給 LocalizationProvider —— dayjs 的 `.locale(物件)` 會直接
// 覆寫 `Ls[name]`，而 `dayjs/locale/en` 沒有 `formats`，會把 localizedFormat plugin
// 補上的 `Ls.en.formats` 清空，導致 adapter 的 `fullDate`（'ll'）格式化時整頁 crash。
import 'dayjs/locale/en';
import 'dayjs/locale/ja';
import 'dayjs/locale/zh-tw';

import { langTypes } from 'config/langType';

/** i18n 語言 → dayjs 語系代碼 */
const localeMap = {
    [langTypes.EN_US]: 'en',
    [langTypes.JA_JP]: 'ja',
    [langTypes.ZH_TW]: 'zh-tw'
};

export default function Provider({ children }) {
    const locale = localeMap[i18n.language] || localeMap[langTypes.ZH_TW];
    return (
        <LocalizationProvider dateAdapter={DayjsUtils} locale={locale}>
            {children}
        </LocalizationProvider>
    );
}

Provider.propTypes = {
    children: PropTypes.element
};
